var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_3102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 0H5C3.67441 0.00158786 2.40356 0.528882 1.46622 1.46622C0.528882 2.40356 0.00158786 3.67441 0 5L0 19C0.00158786 20.3256 0.528882 21.5964 1.46622 22.5338C2.40356 23.4711 3.67441 23.9984 5 24H19C20.3256 23.9984 21.5964 23.4711 22.5338 22.5338C23.4711 21.5964 23.9984 20.3256 24 19V5C23.9984 3.67441 23.4711 2.40356 22.5338 1.46622C21.5964 0.528882 20.3256 0.00158786 19 0V0ZM22 19C22 19.7956 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7956 22 19 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7956 2 19V5C2 4.20435 2.31607 3.44129 2.87868 2.87868C3.44129 2.31607 4.20435 2 5 2H19C19.7956 2 20.5587 2.31607 21.1213 2.87868C21.6839 3.44129 22 4.20435 22 5V19Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33282 15.919L5.41382 12C5.22629 11.8126 4.97198 11.7073 4.70682 11.7073C4.44165 11.7073 4.18735 11.8126 3.99982 12C3.81235 12.1876 3.70703 12.4419 3.70703 12.707C3.70703 12.9722 3.81235 13.2265 3.99982 13.414L7.91882 17.333C8.10455 17.5188 8.32506 17.6662 8.56776 17.7668C8.81047 17.8674 9.07061 17.9191 9.33332 17.9191C9.59603 17.9191 9.85617 17.8674 10.0989 17.7668C10.3416 17.6662 10.5621 17.5188 10.7478 17.333L19.9998 8.08105C20.1873 7.89352 20.2926 7.63922 20.2926 7.37405C20.2926 7.10889 20.1873 6.85458 19.9998 6.66705C19.8123 6.47958 19.558 6.37427 19.2928 6.37427C19.0277 6.37427 18.7733 6.47958 18.5858 6.66705L9.33282 15.919Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_3102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.eacbda57b3e6ffae20a4331a2a2c9386.svg";
export { ForwardRef as ReactComponent };